import { Component, Input, EventEmitter, Output } from '@angular/core';
import { RedeemOptionUI } from '../redemption-v2-modal/redemption-v2-modal.component';
import { MainTemplate, TemplateSetting } from 'projects/kiosk-app/src/app/models/template';
import { StyleService } from 'projects/kiosk-app/src/app/services';

@Component({
  selector: 'app-redemption-v2-option-card',
  templateUrl: './redemption-v2-option-card.component.html',
  styleUrls: ['./redemption-v2-option-card.component.scss']
})
export class RedemptionV2OptionCardComponent {

  @Input() option!: RedeemOptionUI;
  @Output() pick = new EventEmitter<RedeemOptionUI>();

  @Input() tab?: TemplateSetting;
  @Input() mainTemplate?: MainTemplate;

  constructor(public styleService: StyleService) {}
}
